import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/anime';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-flower-line text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                樱花动漫
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              {siteInfo.description.slice(0, 80)}...
            </p>
            <div className="flex items-center gap-3">
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                aria-label="微博"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                aria-label="微信"
              >
                <i className="ri-wechat-line"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                aria-label="B站"
              >
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/all"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  分类浏览
                </Link>
              </li>
              <li>
                <Link
                  to="/category/rexue"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  热血动漫
                </Link>
              </li>
              <li>
                <Link
                  to="/category/maoxian"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  冒险动漫
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              热门分类
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/category/lianai"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  恋爱动漫
                </Link>
              </li>
              <li>
                <Link
                  to="/category/gaoxiao"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  搞笑动漫
                </Link>
              </li>
              <li>
                <Link
                  to="/category/kehuan"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  科幻动漫
                </Link>
              </li>
              <li>
                <Link
                  to="/category/xuanhuan"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  玄幻动漫
                </Link>
              </li>
              <li>
                <Link
                  to="/category/jingsong"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  悬疑动漫
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line text-primary-400"></i>
                {siteInfo.email}
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-phone-line text-primary-400"></i>
                {siteInfo.phone}
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line text-primary-400"></i>
                <span>广州市天河区动漫产业园</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; {new Date().getFullYear()} 樱花动漫 SakuraAnime. All
              rights reserved.
            </p>
            <div className="flex items-center gap-4 text-sm text-background-500">
              <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">
                隐私政策
              </a>
              <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">
                使用条款
              </a>
              <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}